module.exports = __webpack_public_path__ + "static/img/EG@2x.d628002c.jpg";